/* P.Louise — Bundle product information modal */
(function () {
  const cache = new Map();
  let activeModal = null;
  let lastTrigger = null;

  function formatMoney(cents, format) {
    const value = (Number(cents || 0) / 100).toFixed(2);
    const parts = value.split('.');
    const whole = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    const decimal = parts[1];
    const placeholder = /\{\{\s*(\w+)\s*\}\}/;
    const template = format || '£{{amount}}';
    const match = template.match(placeholder);
    const key = match ? match[1] : 'amount';

    const amount = key === 'amount_no_decimals' ? whole
      : key === 'amount_with_comma_separator' ? `${whole},${decimal}`
      : key === 'amount_no_decimals_with_comma_separator' ? whole
      : `${whole}.${decimal}`;

    return template.replace(placeholder, amount);
  }

  function cleanHtml(html) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(html || '', 'text/html');

    doc.querySelectorAll('script, style, link, meta, object, embed').forEach((node) => node.remove());

    doc.querySelectorAll('*').forEach((node) => {
      Array.from(node.attributes).forEach((attribute) => {
        if (attribute.name.toLowerCase().startsWith('on')) {
          node.removeAttribute(attribute.name);
        }
      });
    });

    return doc.body.innerHTML;
  }

  function resetModal(modal) {
    const loading = modal.querySelector('[data-sbb-product-modal-loading]');
    const content = modal.querySelector('[data-sbb-product-modal-content]');
    const error = modal.querySelector('[data-sbb-product-modal-error]');

    if (loading) loading.hidden = false;
    if (content) content.hidden = true;
    if (error) error.hidden = true;

    const accordionTrigger = modal.querySelector('[data-sbb-product-modal-accordion]');
    const accordionPanel = modal.querySelector('[data-sbb-product-modal-accordion-panel]');

    if (accordionTrigger) accordionTrigger.setAttribute('aria-expanded', 'false');
    if (accordionPanel) accordionPanel.hidden = true;
  }

  function populateModal(modal, card, product) {
    const root = card.closest('[data-skincare-bundle-builder]');
    const moneyFormat = root ? root.dataset.moneyFormat : '£{{amount}}';
    const selectedVariantId = Number(card.dataset.variantId || 0);
    const variants = Array.isArray(product.variants) ? product.variants : [];
    const selectedVariant = variants.find((variant) => Number(variant.id) === selectedVariantId) || variants[0];

    let imageUrl = '';

    if (selectedVariant && selectedVariant.featured_image) {
      imageUrl = typeof selectedVariant.featured_image === 'string'
        ? selectedVariant.featured_image
        : selectedVariant.featured_image.src || '';
    }

    if (!imageUrl && Array.isArray(product.images) && product.images.length) {
      imageUrl = typeof product.images[0] === 'string'
        ? product.images[0]
        : product.images[0].src || '';
    }

    if (!imageUrl) imageUrl = card.dataset.image || '';

    const title = modal.querySelector('[data-sbb-product-modal-title]');
    const price = modal.querySelector('[data-sbb-product-modal-price]');
    const image = modal.querySelector('[data-sbb-product-modal-image]');
    const description = modal.querySelector('[data-sbb-product-modal-description]');
    const link = modal.querySelector('[data-sbb-product-modal-link]');
    const errorLink = modal.querySelector('[data-sbb-product-modal-error-link]');
    const loading = modal.querySelector('[data-sbb-product-modal-loading]');
    const content = modal.querySelector('[data-sbb-product-modal-content]');
    const error = modal.querySelector('[data-sbb-product-modal-error]');

    if (title) title.textContent = product.title || card.dataset.name || '';
    if (price) {
      price.textContent = formatMoney(
        selectedVariant ? selectedVariant.price : card.dataset.price,
        moneyFormat
      );
    }

    if (image) {
      image.src = imageUrl;
      image.alt = product.title || card.dataset.name || '';
    }

    if (description) {
      const cleaned = cleanHtml(product.description || '');
      description.innerHTML = cleaned || '<p>More information is available on the full product page.</p>';
    }

    const productUrl = card.dataset.productUrl || '#';
    if (link) link.href = productUrl;
    if (errorLink) errorLink.href = productUrl;

    if (loading) loading.hidden = true;
    if (error) error.hidden = true;
    if (content) content.hidden = false;
  }

  function showError(modal, card) {
    const loading = modal.querySelector('[data-sbb-product-modal-loading]');
    const content = modal.querySelector('[data-sbb-product-modal-content]');
    const error = modal.querySelector('[data-sbb-product-modal-error]');
    const errorLink = modal.querySelector('[data-sbb-product-modal-error-link]');

    if (loading) loading.hidden = true;
    if (content) content.hidden = true;
    if (error) error.hidden = false;
    if (errorLink) errorLink.href = card.dataset.productUrl || '#';
  }

  function openModal(card, trigger) {
    const root = card.closest('[data-skincare-bundle-builder]');
    const modal = root ? root.querySelector('[data-sbb-product-modal]') : null;

    if (!modal) return;

    activeModal = modal;
    lastTrigger = trigger;
    resetModal(modal);

    modal.hidden = false;
    document.body.classList.add('sbb-product-modal-open');

    const closeButton = modal.querySelector('.sbb-product-modal__close');
    if (closeButton) requestAnimationFrame(() => closeButton.focus());

    const jsonUrl = card.dataset.productJsonUrl;

    if (!jsonUrl) {
      showError(modal, card);
      return;
    }

    if (cache.has(jsonUrl)) {
      populateModal(modal, card, cache.get(jsonUrl));
      return;
    }

    fetch(jsonUrl, {
      method: 'GET',
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    })
      .then((response) => {
        if (!response.ok) throw new Error(`Product request failed: ${response.status}`);
        return response.json();
      })
      .then((product) => {
        cache.set(jsonUrl, product);
        populateModal(modal, card, product);
      })
      .catch(() => showError(modal, card));
  }

  function closeModal() {
    if (!activeModal) return;

    activeModal.hidden = true;
    activeModal = null;
    document.body.classList.remove('sbb-product-modal-open');

    if (lastTrigger) {
      lastTrigger.focus();
      lastTrigger = null;
    }
  }

  document.addEventListener('click', (event) => {
    const infoButton = event.target.closest('[data-sbb-product-info]');

    if (infoButton) {
      event.preventDefault();
      event.stopPropagation();

      const card = infoButton.closest('[data-sbb-card]');
      if (card) openModal(card, infoButton);
      return;
    }

    const accordionTrigger = event.target.closest('[data-sbb-product-modal-accordion]');

    if (accordionTrigger) {
      event.preventDefault();

      const modal = accordionTrigger.closest('[data-sbb-product-modal]');
      const panel = modal ? modal.querySelector('[data-sbb-product-modal-accordion-panel]') : null;
      const expanded = accordionTrigger.getAttribute('aria-expanded') === 'true';

      accordionTrigger.setAttribute('aria-expanded', expanded ? 'false' : 'true');
      if (panel) panel.hidden = expanded;
      return;
    }

    if (event.target.closest('[data-sbb-product-modal-close]')) {
      event.preventDefault();
      closeModal();
    }
  }, true);

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && activeModal) closeModal();
  });
})();
